export enum CallLogStatus {
  Answered = 'answered',
  Externeral = 'external',
  Hangup = 'hangup',
  Rejected = 'rejected',
  Unknown = 'unknown',
  Voicemail = 'voicemail',
}

export enum CallLogDirection {
  Inbound = 'inbound',
  Outbound = 'outbound',
  Internal = 'internal',
}

export interface CallLogPhoneNumber {
  phone_number?: string
  caller_id?: string
  location?: string
}

export interface CallLogExtension {
  number: string
}

export interface CallLog {
  id: number
  uuid: string
  pbx_id: number
  direction: CallLogDirection
  from_phone_number?: CallLogPhoneNumber
  from_extension?: CallLogExtension
  to_phone_number?: CallLogPhoneNumber
  to_extension?: CallLogExtension
  status: CallLogStatus
  duration_in_seconds: number
  started_at: string
  ended_at: string
  created_at: string
  updated_at: string
}

/**
 * Note: The additional fields in this object are not available on the collection
 * because they may contain sensitive data and require access logging
 */
export interface CallLogInstance extends CallLog {
  recording_url: string
}
